import { ApiGateway } from '@pasteltech/api-gateway'
import { healthResponseSchema } from '@stewards-fas/schemas'
import { z } from 'zod'

export function getHealth() {
  return ApiGateway.primary.get('/health', {
    request: z.any(),
    response: healthResponseSchema,
  })
}
